














import Vue from 'vue';
import { ITextLineComponent } from '../../../../common/interfaces/frontpage.interface';
import FrontpageHelper from '../../../../helpers/page-specific/FrontpageHelper';

export default Vue.extend({
  name: `TextLine`,
  components: {},
  data(): ITextLineComponent {
    return {
      textLineElement: null,
      visible: false,
    };
  },
  props: {
    line: {
      required: true,
      type: String,
    },
    right: {
      required: false,
      type: Boolean,
    },
    underlined: {
      default: false,
      type: Boolean,
    },
    uppercase: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    this.textLineElement = this.$refs.textline as HTMLDivElement;
    document.addEventListener(`scroll`, this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy(): void {
    document.removeEventListener(`scroll`, this.handleScroll);
  },
  methods: {
    handleScroll(): void {
      if(!this.visible && this.textLineElement) {
        this.visible = FrontpageHelper.isElemVisible(this.textLineElement);
      }
    },
  },
});
